<template>
  <section
    class="lp-cta relative overflow-hidden"
    :style="{
      backgroundColor: section.styles.backgroundColor || '#0f766e',
      padding: section.styles.padding || '5.5rem 1.25rem',
      textAlign: section.styles.textAlign || 'center',
      color: section.styles.textColor || '#ffffff',
    }"
  >
    <div class="lp-cta__pattern" aria-hidden="true" />
    <div class="relative max-w-3xl mx-auto">
      <h2 v-if="section.content.title" class="lp-cta__title">{{ section.content.title }}</h2>
      <p v-if="section.content.subtitle" class="lp-cta__subtitle">{{ section.content.subtitle }}</p>
      <a
        v-if="section.content.ctaText"
        :href="section.content.ctaLink || '#'"
        class="lp-cta__button"
      >
        {{ section.content.ctaText }}
      </a>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.lp-cta__pattern {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 15% 20%, rgba(255, 255, 255, 0.14), transparent 35%),
    radial-gradient(circle at 85% 80%, rgba(0, 0, 0, 0.12), transparent 40%);
  pointer-events: none;
}

.lp-cta__title {
  font-family: var(--ps-font-display);
  font-size: clamp(1.85rem, 3.5vw, 2.75rem);
  font-weight: 700;
  letter-spacing: -0.035em;
  line-height: 1.1;
  margin-bottom: 0.85rem;
}

.lp-cta__subtitle {
  font-size: 1.05rem;
  opacity: 0.9;
  line-height: 1.55;
  max-width: 32rem;
  margin: 0 auto 1.75rem;
}

.lp-cta__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.85rem;
  background: #fff;
  color: #0f172a;
  padding: 0.9rem 1.6rem;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 16px 28px -18px rgba(15, 23, 42, 0.55);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.lp-cta__button:hover {
  transform: translateY(-2px);
  box-shadow: 0 20px 32px -16px rgba(15, 23, 42, 0.5);
}
</style>
